import axios from 'axios';
import authHeader from './auth-header';
import publicHeader from './public-header';

const API_URL = `${process.env.VUE_APP_API_BASE_URL}`;

class ResourceService {
  getResources() {
    return axios.get(`${API_URL}/api/Feature/LookUp/Resource/FormList?originationChannel=1`,
      {
        headers: publicHeader()
      })
      .then(response => {
        return response.data;
      });
  }

  uploadResource(resource) {
    return axios.post(`${API_URL}/api/Feature/Update/FormResources`,
    resource,
      {
        headers: authHeader()
      })
      .then(resp => {
        return resp.data;
      });
  }

  getResourceList() {
    return axios.get(`${API_URL}/api/Feature/Public/Resources`,
      {
        headers: publicHeader()
      })
      .then(response => {
        return response.data;
      });
  }  
}

export default new ResourceService();